import * as bing from "./bing-ads";
import { BingEventData } from "@carsdotcom/fea/lib/providers/BingProvider/types";

/**
 *  Load tracking script & Initialize.
 */
export const loadScriptAndInitializeBingTag = (tagID: string) => {
    window.uetq = window.uetq || [];

    const bingScript: any = document.createElement("script");
    bingScript.async = true;
    bingScript.src = "//bat.bing.com/bat.js";
    bingScript.onload = bingScript.onreadystatechange = () => {
        const bingTrackingObject = { ti: tagID, q: window.uetq };
        const state = bingScript.readyState;
        if (!state || state === "loaded" || state === "complete") {
            // Bing's script creates the UET global for us
            window.uetq = new window.UET(bingTrackingObject);
            bingScript.onload = bingScript.onreadystatechange = null;
        }
    };

    document.getElementsByTagName("head")[0].appendChild(bingScript);
};

/**
 * is script loaded?
 * @return {boolean}
 */
export const isBingScriptLoaded = () => {
    return !!(window.uetq && window.uetq.push !== Array.prototype.push);
};

export const sendBingEvent = (bingTagID: string, payload: BingEventData) => {
    if (!bing.isBingScriptLoaded()) {
        bing.loadScriptAndInitializeBingTag(bingTagID);
    }

    window.uetq.push("event", "", payload);
};
